<template>
  <span>&#160;|&#160;</span>
</template>

<script>
export default {
  name: "Spacer"
};
</script>